import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Alert, ComboBox, Divider, Text } from '@reveni-io/reveni-ui'

import DeleteReturnInstructionModalSkeleton from '../DeleteReturnInstructionModalSkeleton/DeleteReturnInstructionModalSkeleton'
import DeliveryMethodList from '../DeliveryMethodList/DeliveryMethodList'

const DeleteReturnInstructionModalContent = ({
  loading,
  associatedDeliveryMethods,
  replacementId,
  availableReplacements,
  onChangeReplacementId,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  if (loading) {
    return <DeleteReturnInstructionModalSkeleton />
  }

  return (
    <>
      {associatedDeliveryMethods?.length > 0 && (
        <>
          <Text type="bodyMRegular">
            {t(
              'Elige unas nuevas instrucciones de devolución que las reemplacen en los siguientes métodos de devolución.'
            )}
          </Text>
          <DeliveryMethodList deliveryMethods={associatedDeliveryMethods} />
          <ComboBox
            label={t('Nuevas instrucciones de devolución')}
            backgroundColor={theme.colors.background.primary}
            value={replacementId}
            menuItems={availableReplacements?.map(ris => ({
              label: ris.name,
              value: ris.id,
            }))}
            handleChange={onChangeReplacementId}
          />
          <Divider />
        </>
      )}
      <Alert type="warning">{t('Esta acción no se podrá deshacer más adelante. ¿Quieres continuar?')}</Alert>
    </>
  )
}

export default DeleteReturnInstructionModalContent
